import { Button } from "@heroui/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useAuth } from "@/features/auth/AuthProvider";
import { useWorkspaces } from "@/features/workspaces/WorkspaceProvider";

export function LandingPage() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <main className="mx-auto grid min-h-[calc(100vh-5rem)] max-w-6xl place-items-center px-6 py-20 text-center">
      <section className="max-w-3xl">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-accent">
          Your colors, always with you
        </p>
        <h1 className="mt-5 text-5xl font-semibold tracking-tight sm:text-7xl">
          A beautiful home for your color journey.
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg text-muted">
          Securely connect with practitioners and keep your personal palette in
          one private workspace.
        </p>
        <Button
          className="mt-9"
          size="lg"
          onPress={() =>
            session?.isAuthenticated
              ? navigate(`/app/${session.activeTenant?.id ?? ""}`)
              : navigate("/signin", { state: { backgroundLocation: location } })
          }
        >
          {session?.isAuthenticated ? "Open workspace" : "Get started"}
        </Button>
      </section>
    </main>
  );
}

export function WorkspaceHomePage() {
  const { tenantId } = useParams();
  const { activeWorkspace } = useWorkspaces();

  return (
    <main className="mx-auto max-w-6xl px-6 py-16">
      <p className="text-sm font-semibold uppercase tracking-widest text-accent">
        {activeWorkspace?.type.toLowerCase()} workspace
      </p>
      <h1 className="mt-3 text-4xl font-semibold">{activeWorkspace?.name}</h1>
      <p className="mt-4 max-w-xl text-muted">
        Your workspace is ready. New tenant features can use tenant ID{" "}
        <span className="font-mono text-xs">{tenantId}</span> in their routes
        and query keys.
      </p>
    </main>
  );
}

export function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center p-6 text-center">
      <div>
        <h1 className="text-4xl font-semibold">Page not found</h1>
        <a className="mt-4 inline-block text-accent underline" href="/">
          Return home
        </a>
      </div>
    </main>
  );
}
